import * as React from "react";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import { useImageSrc } from "../../hooks/useImageSrc";
import { IMAGES } from "../../themes/constants";
import FallBackImage from "../FallBackImage";
const useStyles = makeStyles(({
  palette,
  typography,
  breakpoints
}) => ({
  logoContainer: {
    padding: `${typography.pxToRem(10)} ${typography.pxToRem(12)}`,
    background: "white",
    textAlign: "center",
    borderRadius: typography.pxToRem(14),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-around",
    border: `${typography.pxToRem(4)} solid ${palette.border.logo}`,
    height: typography.pxToRem(60)
  },
  logoContainerFill: {
    maxHeight: typography.pxToRem(60),
    maxWidth: typography.pxToRem(150),
    [breakpoints.down("xs")]: {
      maxHeight: typography.pxToRem(40)
    }
  },
  logoNoContainerFill: {
    maxHeight: typography.pxToRem(30),
    maxWidth: typography.pxToRem(150)
  },
  parcelNumber: {
    color: "#808285",
    fontSize: typography.pxToRem(7),
    letterSpacing: 0.12
  }
}));

const ParcelLogo = ({
  image,
  parcelNumber,
  className,
  logoStyles,
  shouldFillContainer = false
}) => {
  const styles = useStyles();
  const dpdLogoSrc = useImageSrc(IMAGES.PARCEL_LOGO);
  return shouldFillContainer ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FallBackImage, {
    className: clsx(styles.logoContainerFill, logoStyles),
    src: image || dpdLogoSrc,
    fallBackSrc: dpdLogoSrc,
    alt: ""
  }), parcelNumber && /*#__PURE__*/React.createElement("span", {
    className: styles.parcelNumber
  }, parcelNumber)) : /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.logoContainer, className)
  }, /*#__PURE__*/React.createElement(FallBackImage, {
    className: clsx(styles.logoNoContainerFill, logoStyles),
    src: image || dpdLogoSrc,
    fallBackSrc: dpdLogoSrc,
    alt: ""
  }), parcelNumber && /*#__PURE__*/React.createElement("span", {
    className: styles.parcelNumber
  }, parcelNumber));
};

export default ParcelLogo;